export default "__VITE_ASSET__BphJOTU0__"